/**
 * @param {File} file
 * @return {string} Stable key for a file object.
 */
export const fileKey = file => `${file.name}-${file.size}-${file.lastModified}`;
